import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Client errors (4xx) must never be retried
        const status = error?.response?.status || error?.status
        if (typeof status === 'number' && status >= 400 && status < 500) {
          return false
        }
        // Only network errors or 5xx errors retry, with a maximum of 2 retries
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
      staleTime: 2 * 60 * 1000, // 2 minutes stale time to reuse cached API responses
      gcTime: 10 * 60 * 1000, // Keep unused query data in cache for 10 minutes
    },
  },
})
